import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { ListStyled, InProgressStyled } from "../../theme";
import CircularProgressHooks from "./circularProgressHooks";

export const InProgress = () => {
  return (
    <InProgressStyled>
      <CircularProgressHooks size="40" thickness="4" dark />
    </InProgressStyled>
  );
};

export const LoadingList = ({ count }) => {
  let listSkeleton = [];
  for (let i = 0; i < count; ++i) {
    listSkeleton.push(
      <ListStyled key={i}>
        <div className="detail">
          <Skeleton
            variant="rect"
            height={16}
            width="20%"
            style={{ marginBottom: 5 }}
          />
          <span>
            {" "}
            <Skeleton
              variant="rect"
              height={14}
              width="30%"
              style={{ marginBottom: 5 }}
            />
          </span>
        </div>
        <span>
          <Skeleton
            variant="rect"
            height={20}
            width={20}
            style={{ marginRight: 5 }}
          />
          <Skeleton variant="rect" height={20} width={20} />
        </span>
      </ListStyled>
    );
  }
  return <>{listSkeleton}</>;
};

export const LoadingBox = ({ height, width, styles }) => {
  return (
    <Skeleton variant="rect" height={height} width={width} style={styles} />
  );
};
